import firebase from 'firebase/app';
import { firestore, storage } from 'src/lib/firebaseProject';
import axios from 'axios';

const getSubcollection = async doc => {
  let data = doc.data();
  for (let key in data) {
    const item = data[key];
    if (typeof item === 'object' && item && item.parent) {
      await db(item.parent.id).get(item.id, async itemData => {
        data[key] = itemData;
      });
    }
  }

  return { id: doc.id, ...data };
};

const listElements = queryResult => {
  const elements = queryResult.docs.map(async (doc, _) => {
    return await getSubcollection(doc);
  });

  return Promise.all(elements);
};

const db = collection => {
  const dbRef = firestore.collection(collection);
  const storageRef = storage.ref();
  return {
    storage: () => storageRef,
    collectionRef: () => dbRef,
    docRef: id => dbRef.doc(id),
    count: (onResult, onError = _ => {}) =>
      dbRef
        .get()
        .then(documentSnapshot => {
          onResult(documentSnapshot.size);
        })
        .catch(onError),
    all: (onResult, onError = _ => {}) =>
      dbRef
        .get()
        .then(async queryResult => onResult(await listElements(queryResult)))
        .catch(onError),
    get: (id, onResult, onError = _ => {}) =>
      dbRef
        .doc(id)
        .get()
        .then(async documentSnapshot => {
          onResult(await getSubcollection(documentSnapshot));
        })
        .catch(onError),
    execute: (query, onResult) =>
      query
        .get()
        .then(async queryResult => onResult(await listElements(queryResult))),
    where: (fieldPath, opStr, value, onResult) =>
      dbRef
        .where(fieldPath, opStr, value)
        .get()
        .then(async queryResult => onResult(await listElements(queryResult))),
    set: (id, data, onSuccess, onError = _ => {}) => {
      const timeStamp = new firebase.firestore.FieldValue.serverTimestamp();
      dbRef
        .doc(id)
        .set({ createdAt: timeStamp, updatedAt: timeStamp, ...data })
        .then(onSuccess)
        .catch(onError);
    },
    add: (data, onSuccess, onError = _ => {}) => {
      const timeStamp = new firebase.firestore.FieldValue.serverTimestamp();
      dbRef
        .add({
          createdAt: timeStamp,
          updatedAt: timeStamp,
          ...data,
          isActive: true
        })
        .then(onSuccess)
        .catch(onError);
    },
    update: (id, data, onSuccess, onError = _ => {}) => {
      const timeStamp = new firebase.firestore.FieldValue.serverTimestamp();
      return dbRef
        .doc(id)
        .update({ updatedAt: timeStamp, ...data })
        .then(onSuccess)
        .catch(onError);
    },
    active: (id, onSuccess = _ => {}, onError = _ => {}) => {
      const timeStamp = new firebase.firestore.FieldValue.serverTimestamp();
      dbRef
        .doc(id)
        .update({ updatedAt: timeStamp, isActive: true })
        .then(onSuccess)
        .catch(onError);
    },
    close: (id, onSuccess = _ => {}, onError = _ => {}) => {
      const timeStamp = new firebase.firestore.FieldValue.serverTimestamp();
      dbRef
        .doc(id)
        .update({ updatedAt: timeStamp, isActive: false })
        .then(onSuccess)
        .catch(onError);
    },
    delete: (id, onSuccess = _ => {}, onError = _ => {}) =>
      dbRef
        .doc(id)
        .delete()
        .then(onSuccess)
        .catch(onError),
    destroyBatch: (ids, notify) => {
      let batch = firestore.batch();
      ids.forEach(id => {
        batch.delete(dbRef.doc(id));
      });
      batch
        .commit()
        .then(function() {
          console.log(`${collection} entries successfully deleted!`);
          notify('warning', `${collection} entries successfully deleted!`);
        })
        .catch(function(error) {
          console.error(`Error removing ${collection} entries: `, error);
          notify('error', `Error removing ${collection} entries: ` + error);
        });
    },
    downloadFile: (extension, endpoint, onDownloadProgress) => {
      return axios.get(endpoint, {
        responseType: 'blob',
        params: { extension: extension },
        onDownloadProgress: onDownloadProgress
      });
    }
  };
};

export default db;
